export default "__VITE_ASSET__CzcCYvqI__"